module.exports = __webpack_public_path__ + "img/ปลาคาร์พ.b86e70b1.jpg";